import React from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import { useLocation } from 'react-router-dom';
import { useStoreContext } from '../../Contexts/StoreContext';
import { TbClock, TbShoppingBag } from 'react-icons/tb';
import { useCartContext } from '../../Contexts/CartContext';
import SelectedProduct from './Product/SelectedProduct';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import BadgeIndicator from './Product/BadgeIndicator';
import { useStoreHook } from '../../Hooks/StoreHook';
import BoxContentStoreOrderTypeHeader from './BoxContentStoreOrderTypeHeader';
import BoxContentSearchHeader from './BoxContentSearchHeader';
import HeaderLogo from './HeaderLogo';
import ButtonLoginSSO from './ButtonLoginSSO';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { HiBars3 } from 'react-icons/hi2';
import Button from '../Form/Button';
import { useTranslation } from 'react-i18next';
import { useOrderHook } from '../../Hooks/OrderHook';

const Header = () => {

    const { isAuthenticated } = useLoginContext();
    const { currentStore } = useStoreContext();
    const { setShowMainMenu } = useLayoutContext();
    const { t } = useTranslation();

    const { currentCart, loadingCurrentCart, loadingUpdateQuantity, setShowCart, getTotalQuantityProductsInConference, currentCartHasItems } = useCartContext();
    const { order } = useCheckoutContext();
    const { getLinkToHome } = useStoreHook();
    const { goToOrderView } = useOrderHook();

    const location = useLocation();
    const isHome = location.pathname === getLinkToHome();
    const isProductPage = new RegExp(`^${getLinkToHome().replace('/', '\\/')}/produto/`).test(location.pathname);

    const handleOpenCart = () => {
        setShowCart(true);
    }

    return (
        <header id="boxHeader" className="flex flex-col w-full justify-between sticky bg-custom-header top-0 z-30 text-custom-header-text">
            <section className='flex justify-center h-20 shadow-sm shadow-black/5'>
                <div className="flex p-4 items-center justify-between w-full md:max-w-[1460px] gap-4 md:gap-6">

                    {/* LOGO */}
                    <HeaderLogo className='min-h-20' />

                    <div className='flex items-center justify-end w-full gap-4 md:gap-6'>

                        {/* SEARCH */}
                        <BoxContentSearchHeader show={currentStore && (isHome || isProductPage)} />

                        <div className="flex items-center gap-2 md:gap-4 h-full">
                            <BoxContentStoreOrderTypeHeader sizeButton={22} />

                            <div className="hidden md:flex items-center gap-2 md:gap-2 h-full">

                                {(currentStore && order && isAuthenticated) &&
                                    <Button
                                        rounded
                                        gray
                                        onClick={() => goToOrderView(order.id)}
                                        className='zoomInicon'>
                                        <div className='relative'>
                                            <TbClock size={23} />
                                            {(currentStore.shipping_time && currentStore.shipping_time > 0) && <BadgeIndicator quantity={currentStore.shipping_time} className="-top-4 -right-4" />}
                                        </div>
                                    </Button>
                                }

                                <div className='relative'>
                                    <Button
                                        rounded
                                        gray
                                        disabled={!currentCartHasItems}
                                        onClick={handleOpenCart}
                                        className='text-custom-primary disabled:text-gray-600'>
                                        <div><TbShoppingBag size={23} /></div>
                                        <SelectedProduct alwaysNotify={false} loading={loadingCurrentCart || loadingUpdateQuantity} animated={false} quantity={currentCart ? getTotalQuantityProductsInConference(currentCart.items) : 0} className="rounded-lg -top-0.5 -right-0.5" />
                                    </Button>
                                </div>

                                { !isAuthenticated && <ButtonLoginSSO asButtonGray hasLinkIcon labelLink={t('login.label_button_login')} />}

                                <Button 
                                    rounded 
                                    gray
                                    onClick={() => setShowMainMenu(true)}
                                    className='hidden md:flex '>
                                    <div><HiBars3 size={23} /></div>
                                </Button>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </header>
    );
};

export default Header;
